import { Component } from '@angular/core';

@Component({
  selector: 'app-billing-overview',
  templateUrl: './billing-overview.component.html',
  styleUrl: './billing-overview.component.scss'
})
export class BillingOverviewComponent {

  plan = {
    name: 'Basic plan',
    type: 'Monthly',
    billing: 'Month',
    price: 500,
    currency: '$',
    users: 7,
    maxUsers: 10,
  };

  billingHistory = [
    { invoice: 'Basic Plan - Mar 2024', amount: 500, date: 'Mar 1, 2025', status: 'Paid' },
    { invoice: 'Basic Plan - Feb 2024', amount: 500, date: 'Feb 1, 2025', status: 'Paid' },
    { invoice: 'Basic Plan - Jan 2024', amount: 500, date: 'Jan 1, 2025', status: 'Paid' },
    { invoice: 'Basic Plan - Dec 2024', amount: 500, date: 'Dec 1, 2024', status: 'Paid' },
    { invoice: 'Basic Plan - Nov 2024', amount: 500, date: 'Nov 1, 2024', status: 'Paid' },
    { invoice: 'Basic Plan - Oct 2024', amount: 500, date: 'Oct 1, 2024', status: 'Paid' },
    { invoice: 'Basic Plan -Sep 2024', amount: 500, date: 'Sep 1, 2024', status: 'Paid' },
  ];

  downloadInvoice(invoice: string) {
    console.log(`Downloading invoice: ${invoice}`);
    // Implement actual download logic
  }

}
